import { render, staticRenderFns } from "./PoliciesInfoNav.vue?vue&type=template&id=4a8d804d&"
import script from "./PoliciesInfoNav.vue?vue&type=script&lang=js&"
export * from "./PoliciesInfoNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports